module.exports = {
    RECEIVE_EXPLOITATION: 'RECEIVE_EXPLOITATION',
    RECEIVE_EXPLOITATIONS_DATA: 'RECEIVE_EXPLOITATIONS_DATA',
    RECEIVE_EXPLOITATION_VOLUMES: 'RECEIVE_EXPLOITATION_VOLUMES',
    RECEIVE_WATERTURNS: 'RECEIVE_WATERTURNS',
    RECEIVE_WATERTURNS_EXPLOITATION: 'RECEIVE_WATERTURNS_EXPLOITATION',
    RESET_EXPLOIT: 'RESET_EXPLOIT',
}
